import axios from 'axios'
import qs from 'qs'

const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
  setTimeout(() => reject(TIMEOUT), 10e3)

export default {
  // 获取优惠券列表和总金额
  getCouponList () {
    const url = '/dashboard/ticket/list'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取礼品卡列表
  getGiftCardList () {
    const url = '/dashboard/giftcard/list'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 兑换礼品卡
  exchangeGiftcard(params) {
    const url = '/dashboard/exchangecode/exchange'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 查询用户余额
  getBalance () {
    const url = '/dashboard/user/balance'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取操作流水
  getBalanceOperateList (params) {
    const url = '/dashboard/user/balance-operate/list'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 创建余额订单
  createBalanceOrder (params) {
    const url = '/dashboard/order/balance/create'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 创建汇款单
  createRemittance (params) {
    const url = '/dashboard/remittance/create'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 汇款单列表
  getRemittanceList (params) {
    const url = '/dashboard/remittance/list'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取礼包状态
  getGiftStatus () {
    const url = '/dashboard/user/giftpackages/status'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 检查用户是否已经设置支付密码
  getSetPwdStatus () {
    const url = '/dashboard/user/pay-password/check'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取极验验证码信息
  getGeeTestInfo () {
    const url = '/dashboard/login/gee-captcha'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取礼包列表
  getGiftList () {
    const url = '/dashboard/giftPackage/list'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取礼包对应appid列表
  getAppList ({
    packageId
  }) {
    const url = '/dashboard/giftPackage/appList?packageId=' + packageId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取礼包对应appid列表
  getTTSList ({
    appId
  }) {
    const url = '/dashboard/business/online-auth-list?businessId=online_tts&appId' + appId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 激活礼包
  createGift ({
    id,
    appId,
    fun
  }) {
    const url = '/dashboard/giftPackage/activate/' + id
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify({appId, fun}))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  checkIdcard (params) {
    const url = '/dashboard/user/secure/update/check-id-card'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 创建银行虚拟账号
  createDM() {
    const url = '/dashboard/remittance/create_dm'
    return new Promise((resolve, reject) => {
      axios.post(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取用户银行专属账户
  getDMInfo() {
    const url = '/dashboard/remittance/get_dm_info'
    return new Promise((resolve, reject) => {
      axios.post(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 短信发送专属账号信息
  sendBankSMS(params) {
    const url = '/dashboard/remittance/bank_sms'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取政策分类
  getPolicyCategoryList(params) {
    const url = '/dashboard/policy/getCategory'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./app/api/account.js